import { createSelector } from 'reselect';
import { FLAG_KEYS } from 'lib/constants';
import { getLaunchDarklyFlags } from './getLaunchDarklyFlags';
import { getIsMESEnabled } from './getIsMESEnabled';
import { getIsErpDriven } from './getIsErpDriven';

/**
 * Whether the Pennex D365 material-picking feature is active for the current
 * machine. Requires the LaunchDarkly flag and an MES machine whose jobs are
 * operator-selected ("Driven by MachineMetrics" / ShopPulse in the MES settings),
 * not ERP-driven. MES always has labor tickets and work order flow on, so the
 * start flow reaches the pick step and the operation's submitted labor tickets
 * are loaded for the Materials Log and the labor form's coverage check. Enabling
 * this flag also turns on barcode scanning (see getBarcodeScanningEnabled), since
 * picking is scan-only.
 */
const getMaterialPickingEnabled = createSelector(
  [getLaunchDarklyFlags, getIsMESEnabled, getIsErpDriven],
  (flags, isMESEnabled, isErpDriven) => {
    const featureFlagEnabled =
      flags?.[FLAG_KEYS.MATERIAL_PICKING_ENABLED] || false;

    return featureFlagEnabled && isMESEnabled && !isErpDriven;
  }
);

export { getMaterialPickingEnabled };
